import * as React from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import TextField from '@mui/material/TextField'

type DatePickerFieldProps = {
    value: Dayjs | null,
    setValue: (value: Dayjs | null) => void,
    label: string,
    disabled: boolean
}

const DatePickerField = (props: DatePickerFieldProps) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disabled={props.disabled}
                label={props.label}
                value={props.value}
                slots={{
                    textField: (params) => <TextField size="small" {...params} />

                }}
                format="DD.MM.YYYY"
                onChange={(newValue) => props.setValue(newValue)}
            />
        </LocalizationProvider>
    )
}

export default DatePickerField